import proxy from '@sigma-legacy-libs/g-proxy'

import ipWhitelist from '@/components/services/settings/smpp/ipWhitelist'

export default function() {
  return {
    name: 'SMPPIPWhitelist',

    mixins: [ proxy({ type: 'array' }) ],

    props: {
      loading: {
        type: Object,
        default: () => ({})
      }
    },

    render(h) {
      return h(
        ipWhitelist,
        {
          props: {
            value: this.value,
            loading: this.loading
          },
          on: {
            input: event => {
              this.$emit('input', event)
            }
          }
        }
      )
    }
  }
}
